import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import AOS from 'aos';
import 'aos/dist/aos.css';
Vue.config.productionTip = false
AOS.init({
  duration: 700,
  mirror: false,
  once: true

});
new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
